<template>
  <layout-full>
    <router-view />


    <!-- Using navbar scoped slot -->
    <div
      slot="navbar"
      class="px-1"
    >
        <!-- Nav Menu Toggler -->
    <ul class="nav navbar-nav d-xl-none">
      <li class="nav-item">
        <b-link
          class="nav-link"
          @click="toggleVerticalMenuActive"
        >
          <feather-icon
            icon="MenuIcon"
            size="21"
          />
        </b-link>
      </li>
    </ul>
      <p class="mb-0">I am in navbar, Everything else is removed</p>
    </div>
  <div
      slot="breadcrumb"
      class="p-1"
    >
      <!-- I am custom breadcrumb full -->
    </div>
   

  </layout-full>
</template>

<script>
import LayoutFull from '@core/layouts/layout-full/LayoutFull.vue'

export default {
  components: {
    LayoutFull,
  },
  props: {
    toggleVerticalMenuActive: {
      type: Function,
      default: () => {},
    },
  },
}
</script>
